<template>
  <div class="vendor-code-rule-container">
    <div class="form-wrapper">
      <el-form
          :model="ruleForm"
          label-width="120px"
          ref="ruleFormRef"
          class="compact-form"
      >
        <h3 class="form-title">供应商代码生成规则配置</h3>

        <!-- 首字母配置区域 -->
        <el-form-item label="首字母配置：" prop="prefixConfig">
          <el-row :gutter="8" class="prefix-grid">
            <el-col
                :span="8"
                v-for="item in codeItems"
                :key="item.itemValue"
                class="form-col"
            >
              <el-form-item
                  :label="item.itemText"
                  class="compact-item"
                  label-width="120px"
              >
                <template slot="label">
                  <el-tooltip
                      :content="item.itemText"
                      placement="top"
                      :disabled="item.itemText.length <= 8"
                  >
                    <span class="item-text-label">{{ item.itemText }}</span>
                  </el-tooltip>
                </template>
                <el-input
                    v-model="ruleForm[item.itemValue.toLowerCase()]"
                    placeholder="输入"
                    size="mini"
                    class="narrow-input"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>

        <!-- 流水号长度和保存按钮 -->
        <el-row :gutter="20" class="bottom-row">
          <el-col :span="12">
            <el-form-item label="流水号长度：" class="serial-number">
              <el-input-number
                  v-model="ruleForm.numLength"
                  :min="1"
                  :max="10"
                  controls-position="right"
                  size="mini"
                  class="number-input"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" class="button-col">
            <el-form-item>
              <el-button
                  type="primary"
                  @click="submitForm"
                  size="mini"
                  class="submit-btn"
              >
                保存
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import {updateVenderCodeRule, queryVenderCodeRule} from '@/controller/systemData'
import {listItems} from '@/controller/sys'

export default {
  data() {
    return {
      ruleForm: {
        numLength: 3,
      },
      codeItems: [],
      originalRuleData: null
    };
  },
  async created() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      try {
        // 1. 先加载字典项
        await this.loadCodeItems();
        // 2. 再加载规则数据
        await this.query();
      } catch (error) {
        console.error('初始化数据失败:', error);
        this.$message.error('初始化数据失败');
      }
    },

    async loadCodeItems() {
      const response = await listItems({
        'codeType': 'BU_GROUP'
      });
      if (response && response.code === '00') {
        // 注意这里取 response.body.body
        this.codeItems = response.body.body || [];
        console.log('加载的字典项:', this.codeItems);
      } else {
        this.$message.error(response?.message || '加载字典项失败');
      }
    },

    async query() {
      const response = await queryVenderCodeRule();
      if (response && response.code === '00') {
        this.originalRuleData = response.body;
        console.log('规则数据:', this.originalRuleData);
        this.initializeFormData(this.originalRuleData);
      } else {
        this.$message.error(response?.message || '获取规则失败');
      }
    },

    initializeFormData(ruleData) {
      // 初始化基本字段
      this.ruleForm = {
        numLength: ruleData.numLength || 3
      };

      // 为每个字典项初始化表单字段
      this.codeItems.forEach(item => {
        // 注意：直接使用itemValue作为key（保持大写）
        const key = item.itemValue; // V002, VA01等
        const ruleDataKey = key.toLowerCase(); // v002, va01等
        this.$set(this.ruleForm, key.toLowerCase(), ruleData[ruleDataKey] || '');
      });

      console.log('初始化后的表单数据:', this.ruleForm);
    },

    submitForm() {
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          this.updateVenderCodeRule();
        } else {
          this.$message.error('表单验证失败，请检查输入');
        }
      });
    },

    async updateVenderCodeRule() {
      const params = {
        ...this.originalRuleData,
        numLength: this.ruleForm.numLength,
        ...this.prepareRuleData()
      };

      try {
        const response = await updateVenderCodeRule(params);
        if (response && response.code === '00') {
          this.$message.success('保存成功');
          this.originalRuleData = response.body;
          await this.query(); // 重新加载最新数据
        } else {
          this.$message.error(response?.message || '保存失败');
        }
      } catch (error) {
        console.error('保存失败:', error);
        this.$message.error('保存失败: ' + (error.message || '服务器错误'));
      }
    },

    prepareRuleData() {
      const ruleData = {};
      this.codeItems.forEach(item => {
        const key = item.itemValue; // 保持原样（V002, VA01等）
        const value = this.ruleForm[key.toLowerCase()];
        if (value !== undefined) {
          ruleData[key.toLowerCase()] = value; // 使用大写的key对应后端字段
        }
      });
      return ruleData;
    }
  }
};
</script>

<style scoped>.vendor-code-rule-container {
  width: 100%;
  height: 100vh;
  padding: 0;
  margin: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.form-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
}

.compact-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  padding-right: 10px;
}

.form-title {
  margin-top: 0;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

/* 输入框样式调整 */
.narrow-input {
  width: 80px; /* 固定输入框宽度 */
}

.serial-number {
  margin: 0;
}

.serial-number ::v-deep .el-form-item__content {
  margin-left: 0 !important;
  display: flex;
  align-items: center;
}

.serial-number ::v-deep .el-form-item__label {
  font-size: 14px;
  white-space: nowrap;
}

.number-input {
  width: 100px;
  margin-left: 10px;
}

.submit-btn {
  flex-shrink: 0;
}

.bottom-row {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.button-col {
  display: flex;
  justify-content: flex-end;
}

.button-col ::v-deep .el-form-item {
  margin-bottom: 0;
}

.button-col ::v-deep .el-form-item__content {
  margin-left: 0 !important;
}

/* 网格布局调整 */
.prefix-grid {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;
  width: 100%;
}

.form-col {
  flex: 0 0 33.333%;
  max-width: 33.333%;
  padding: 0 5px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.compact-item {
  margin-bottom: 0;
}

.compact-item ::v-deep .el-form-item__label {
  width: 120px !important;
  padding-right: 5px;
  font-size: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
}

.compact-item ::v-deep .el-form-item__content {
  flex-wrap: nowrap;
}

.item-text-label {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .form-col {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .compact-item ::v-deep .el-form-item__label {
    width: 100px !important;
  }
}

@media (max-width: 768px) {
  .form-col {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .compact-item ::v-deep .el-form-item__label {
    width: 90px !important;
  }

  .narrow-input {
    width: 60px;
  }

  .form-wrapper {
    padding: 10px;
  }

  .compact-form {
    padding-right: 5px;
  }

  .bottom-row {
    flex-direction: column;
  }

  .button-col {
    justify-content: flex-start;
    margin-top: 15px;
  }
}
</style>
